import React, { useContext } from 'react';
import { HSOptions } from '../../../constants/HSOptions';
import Select from '../Select';
import { FormContext } from '../Form';
import Row from '../../layout/Row';

const AutoSelectAndUpgrade = ({ isAward, ...props }) => {
    const { values, setValue } = useContext(FormContext);

    const autoSelect = [...HSOptions.washClub.autoSelect];
    const allowUpgrades = [...HSOptions.washClub.allowUpgrades];
    const boolAllowUpgrades = [...HSOptions.washClub.boolAllowUpgrades];

    if (isAward) {
        autoSelect.shift();
        allowUpgrades.shift();
    }

    const autoVal = values[props.upgrades || 'allowUpgrades'];
    const capAutoVal = autoVal !== undefined ? autoVal.toString().charAt(0).toUpperCase() + autoVal.toString().slice(1).toLowerCase() : 'UseDefault';
    const YesNo = ['True', 'False'];
    const filterIt = YesNo.includes(capAutoVal);
    const filteredValues = autoSelect.filter(e => YesNo.includes(e.value));
    const allowedIndex = boolAllowUpgrades.findIndex(e => e.value === values.allowUpgrades);
    const selectIndex = boolAllowUpgrades.findIndex(e => e.value === values.autoSelect);
    const upgradesToShow = allowUpgrades ? allowUpgrades[allowedIndex] : 'UseDefault';
    const selectToShow = autoSelect ? allowUpgrades[selectIndex] : 'UseDefault';

    return (
        <Row wrap>
            <Select
                label='Allow Upgrades'
                name={props.upgrades || 'allowUpgrades'}

                options={allowUpgrades}
                value={ upgradesToShow?.value }

                required
            >
            </Select>
             <Select
                label='Auto Select'
                name={props.select || 'autoSelect'}
                value={ selectToShow?.value}
                options={filterIt ? filteredValues : autoSelect.filter(e => e.value === autoVal)}

                required
            /> 
        </Row>
    )
}

export default AutoSelectAndUpgrade;
